<template>
  <v-layout justify-center>
    <v-flex>
      <panel :title="$t('siteDetails.createSite')">
        <v-text-field
          :label="$t('siteGenerics.siteName')"
          required
          :rules="[required]"
          v-model="site_name"
        ></v-text-field>
        <v-text-field
          :label="$t('siteGenerics.siteDescr')"
          required
          :rules="[required]"
          v-model="description"
        ></v-text-field>
        <timezone-selector
          :defaultTimezone="time_zone"
          @timezoneSelected="tz => {
              time_zone = tz.timezone,
              country = tz.country
            }"
        />
        <v-text-field
          :label="$t('siteGenerics.voluntaryPeriod')"
          required
          type="number"
          :rules="[required]"
          v-model="voluntary_period"
        ></v-text-field>
        <v-text-field
          :label="$t('siteGenerics.earlyCheckForPregnancy')"
          required
          :rules="[required]"
          v-model="early_check_for_pregnancy"
        ></v-text-field>
        <v-text-field
          :label="$t('siteGenerics.dryOff')"
          required
          type="number"
          :rules="[required]"
          v-model="dry_off"
        ></v-text-field>
        <sensitivity-selector :defaultSensitivity="sensitivity" :sensitivities="['OFF', 'LOW', 'MEDIUM', 'HIGH']" @sensitivitySelected="s => {sensitivity = s.sensitivity}"/>
        <v-checkbox v-model="auto_pregnancy_confirm" :label="$t('siteGenerics.autoPregCheck')"></v-checkbox>
        <v-checkbox v-model="auto_dismiss" :label="$t('siteGenerics.autoDismiss')"></v-checkbox>
        <v-text-field
          v-if="auto_dismiss"
          :label="$t('siteGenerics.autoDismissDays')"
          v-model="auto_dismiss_days"
        ></v-text-field>
        <v-checkbox v-model="is_seasonal_breeding" :label="$t('siteGenerics.isSeasonalBreeding')"></v-checkbox>
        <v-select
          :items="incrDecrOptions"
          v-model="inc_dec_activity_alerts"
          item-text="name"
          item-value="value"
          :label="$t('siteGenerics.incDecActivityAlerts')"
        >
        </v-select>
        <v-layout mb-3>
          <v-flex align-self-center xs6>
            <v-layout>
              <date-time-picker-with-zone
                v-if="is_seasonal_breeding"
                :label="$t('graph.from')"
                @dateChanged="newDate => (sb_from_date = newDate)"
                :actDate="sb_from_date"
                noTime
              />
            </v-layout>
          </v-flex>
          <v-flex align-self-center xs12>
            <v-layout>
              <date-time-picker-with-zone
                v-if="is_seasonal_breeding"
                :label="$t('graph.to')"
                @dateChanged="newDate => (sb_to_date = newDate)"
                :actDate="sb_to_date"
                noTime
              />
            </v-layout>
          </v-flex>
        </v-layout>
        
        <div class="danger-alert" v-if="error">{{ error }}</div>
        <v-btn dark class="secondary" @click="create">{{ $t("siteDetails.createSite") }}</v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import SitesService from '@/services/SitesService';
import UtilsService from '@/services/UtilsService';
import i18n from '../plugins/i18n';

export default {
  data() {
    return {
      site_name: null,
      description: null,
      time_zone: null,
      country: null,
      auto_pregnancy_confirm: false,
      early_check_for_pregnancy: 0,
      auto_dismiss: false,
      auto_dismiss_days: 3,
      is_seasonal_breeding: false,
      sb_from_date: null,
      sb_to_date: null,
      error: null,
      inc_dec_activity_alerts: 'BOTH',
      voluntary_period: null,
      dry_off: null,
      sensitivity: null,
      required_fields: ['site_name', 'description', 'time_zone', 'country'],
      required: value => !!value || 'Required.',
      incrDecrOptions: [
        { name: this.$t('siteGenerics.incrDecrOptions.incrOnly'), value: 'INCR' },
        { name: this.$t('siteGenerics.incrDecrOptions.decrOnly'), value: 'DECR' },
        { name: this.$t('siteGenerics.incrDecrOptions.both'), value: 'BOTH' },
        { name: this.$t('siteGenerics.off'), value: 'NONE' }
      ],
    };
  },
  methods: {
    async create() {
      this.error = null;
      let areAllFieldsFilledIn = true;
      const data = {
        site_name: this.site_name,
        description: this.description,
        country: this.country,
        time_zone: this.time_zone,
        voluntary_period: +this.voluntary_period,
        dry_off: +this.dry_off,
        auto_pregnancy_confirm: this.auto_pregnancy_confirm,
        auto_dismiss: this.auto_dismiss,
        is_seasonal_breeding: this.is_seasonal_breeding,
        inc_dec_activity_alerts: this.inc_dec_activity_alerts,
        early_check_for_pregnancy: this.early_check_for_pregnancy
      }
      
      // Optional fields
      if(this.sensitivity) {
        data['sensitivity'] = this.sensitivity;
      }
      
      // Conditional fields
      if(this.auto_dismiss) {
        data['auto_dismiss_days'] = +this.auto_dismiss_days;
        if(!data['auto_dismiss_days']) {
          areAllFieldsFilledIn = false;
        }
      }
      
      if(this.is_seasonal_breeding) {
        data['sb_from_date'] = UtilsService.formatRequestDate(this.sb_from_date).split("T")[0];
        data['sb_to_date'] = UtilsService.formatRequestDate(this.sb_to_date).split("T")[0];
        if(!data['sb_from_date'] || !data['sb_to_date']) {
          areAllFieldsFilledIn = false;
        }
      }
      
      if(!this.required_fields.every(key => !!data[key])) {
        areAllFieldsFilledIn = false;
      }

      if (!areAllFieldsFilledIn) {
        this.error = i18n.t('mainErrors.fieldsRequired');
        return;
      }

      try {
        await SitesService.post(data);
        this.$emit('close'); // notify parent to close the modal
      } catch (error) {
        this.error = error.response.data;
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/CreateSite.vue